import { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";

const Contact = () => {
  const [capVal, setCapVal] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wbw24pu",
        "template_0hgt3yv",
        e.target,
        "Kh5k0K1qs98wTpbZV"
      )
      .then(() => {
        alert("✅ Message sent successfully!");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error sending email:", error);
      });
  };

  return (
    <section className="contact-section py-5" id="contact-sec">
      <div className="container">
        {/* Header */}

        <div className="title-area text-center mb-5" data-aos="fade-up">
          <div className="shadow-title">Contact</div>
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots" />
            </span>
            Get In Touch
            <span className="shape right">
              <span className="dots" />
            </span>
          </span>
          <h2 className="sec-title fw-semibold">Have Some Questions?</h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>
            Thank you for your interest in our services. Fill out the form or
            reach us directly — we’ll respond as soon as possible.
          </p>
        </div>

        {/* Contact Info & Form */}
        <div className="row align-items-center g-5">
          {/* Contact Info */}
          <div className="col-lg-5" data-aos="fade-right">
            <div className="info-card shadow-lg p-4 rounded-4 bg-white">
              <h4 className="fw-bold text-success mb-3">Contact Information</h4>
              <p>
                <i className="fas fa-phone me-2 text-success" />
                <a
                  href="tel:+18139941164"
                  className="text-dark text-decoration-none fw-semibold"
                >
                  +1 (813) 994-1164
                </a>
              </p>
              <p>
                <i className="fas fa-envelope me-2 text-success" />
                <a
                  href="mailto:info@integrity-mt.com"
                  className="text-dark text-decoration-none fw-semibold"
                >
                  info@integrity-mt.com
                </a>
              </p>
              <p>
                <i className="fas fa-map-marker-alt me-2 text-success" />
                6151 Old Pasco Rd, Wesley Chapel, FL 33544
              </p>
              <div className="mt-4">
                <iframe
                  title="IMT Location"
                  className="w-100 rounded-4 border-0 shadow-sm"
                  height="250"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5693.046674878132!2d-82.35758969999999!3d28.247441400000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa1f4e7828559f87f%3A0xb9ff805ca8bf4a4a!2sIntegrity%20Materials%20Testing!5e1!3m2!1sen!2sus!4v1761586028968!5m2!1sen!2sus"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-7" data-aos="fade-left">
            <form
              onSubmit={sendEmail}
              className="p-5 bg-white shadow-lg rounded-4 contact-form"
              style={{ borderTop: "5px solid #198754" }}
            >
              <h3 className="fw-bold mb-4" style={{ color: "#198754" }}>
                Request Scheduling
              </h3>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Full Name*</label>
                  <input
                    type="text"
                    name="fullName"
                    className="form-control rounded-pill"
                    placeholder="Enter your full name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Email*</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control rounded-pill"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Phone*</label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-control rounded-pill"
                    placeholder="(123) 456-7890"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Subject*</label>
                  <input
                    type="text"
                    name="subject"
                    className="form-control rounded-pill"
                    placeholder="Subject"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label fw-semibold">Message*</label>
                  <textarea
                    name="message"
                    className="form-control rounded-4"
                    rows="4"
                    placeholder="Write your message..."
                    required
                  ></textarea>
                </div>

                {/* reCAPTCHA with dynamic message */}
                <div className="col-12 d-flex flex-column align-items-center mt-2">
                  <ReCAPTCHA
                    sitekey="6LckIrcpAAAAAEKIsF1phIPq_I_s4xQDXwuK1qut"
                    onChange={(val) => setCapVal(val)}
                    onExpired={() => setCapVal(null)}
                  />
                  {!capVal && (
                    <small className="text-danger d-block mb-2">
                      Please verify you’re not a robot before sending.
                    </small>
                  )}
                </div>

                <div className="col-12 text-center">
                  <button
                    type="submit"
                    disabled={!capVal}
                    className="btn px-5 py-2 rounded-pill mt-3"
                    style={{
                      backgroundColor: "#198754",
                      color: "white",
                      fontWeight: "600",
                      letterSpacing: "1px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "white";
                      e.target.style.color = "#198754";
                      e.target.style.border = "2px solid #198754";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#198754";
                      e.target.style.color = "white";
                      e.target.style.border = "none";
                    }}
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style>{`

        .info-card {
          border-top: 4px solid #198754;
          transition: transform 0.4s ease, box-shadow 0.4s ease;
        }
        .info-card:hover {
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        }
        .contact-form textarea {
          resize: none;
        }
        .fade-in {
          opacity: 1;
          animation: fadeIn 0.4s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(5px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .sec-title {
          color: #000;
        }
      `}</style>
    </section>
  );
};

export default Contact;
